import React from 'react';
import { useParams } from 'react-router-dom';
import ReferenceResponse from '../components/verification/ReferenceResponse';
import './ReferenceResponsePage.css';

const ReferenceResponsePage = () => {
  const { token } = useParams();

  return (
    <div className="reference-page-container">
      <header className="reference-page-header">
        <div className="brand">
          <span className="brand-logo">TV</span>
          <span className="brand-name">TenantVerify SA</span>
        </div>
      </header>
      
      <main className="reference-page-main">
        <ReferenceResponse referenceToken={token} />
      </main>
      
      <footer className="reference-page-footer">
        <p>&copy; {new Date().getFullYear()} TenantVerify SA. All rights reserved.</p>
        <p>Your data is processed securely in accordance with our Privacy Policy.</p>
      </footer>
    </div>
  );
};

export default ReferenceResponsePage;
